import { render } from "./ContentGrid.vue?vue&type=template&id=f00e2312&scoped=true"
import script from "./ContentGrid.vue?vue&type=script&lang=js"
export * from "./ContentGrid.vue?vue&type=script&lang=js"

import "./ContentGrid.vue?vue&type=style&index=0&id=f00e2312&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00e2312"]])

export default __exports__